import { CURRENT_ENV } from './Env';

// Apps for testing
export const INTEGRATIONS_DEMO = {
  NETSUITE_DEMO: 'NETSUITE_DEMO',
  DEVHUBTESTAPP: 'DEVHUBTESTAPP',
  DEMO_APP: 'DEMO_APP'
};

// DataSync Apps
export const INTEGRATIONS_DATA_SYNC = {
  MSDYNAMICS: 'MSDYNAMICS',
  NETSUITE: 'NETSUITE',
  SALESLOFT: 'SALESLOFT',
  ZOHOCRM: 'ZOHOCRM',
  SHOPIFY_DATA_SYNC: 'SHOPIFY_DATA_SYNC',
  QUICKBOOKS_DATA_SYNC: 'QUICKBOOKS_DATA_SYNC',
  SALESFORCE_DATA_SYNC: 'SALESFORCE_DATA_SYNC'
};

// AI Connector Apps
export const INTEGRATIONS_AI_CONNECTORS = {
  CHAT_GPT_CONNECTOR: 'CHAT_GPT_CONNECTOR',
  CLAUDE_CONNECTOR: 'CLAUDE_CONNECTOR'
};

// Dashworks/Breeze Apps
export const INTEGRATIONS_DASHWORKS = {
  ASANA_BREEZE: 'ASANA_BREEZE',
  AZURE_DEVOPS_BREEZE: 'AZURE_DEVOPS_BREEZE',
  BOX_BREEZE: 'BOX_BREEZE',
  CONFLUENCE_BREEZE: 'CONFLUENCE_BREEZE',
  DOCUMENT360_BREEZE: 'DOCUMENT360_BREEZE',
  DROPBOX_BREEZE: 'DROPBOX_BREEZE',
  GITBOOK_BREEZE: 'GITBOOK_BREEZE',
  GMAIL_BREEZE: 'GMAIL_BREEZE',
  GOOGLE_DRIVE_BREEZE: 'GOOGLE_DRIVE_BREEZE',
  GURU_BREEZE: 'GURU_BREEZE',
  HELPJUICE_BREEZE: 'HELPJUICE_BREEZE',
  JIRA_BREEZE: 'JIRA_BREEZE',
  LINEAR_BREEZE: 'LINEAR_BREEZE',
  MSTEAMS_BREEZE: 'MSTEAMS_BREEZE',
  ONEDRIVE_BREEZE: 'ONEDRIVE_BREEZE',
  OUTLOOK_BREEZE: 'OUTLOOK_BREEZE',
  PRODUCTBOARD_BREEZE: 'PRODUCTBOARD_BREEZE',
  README_BREEZE: 'README_BREEZE',
  SHAREPOINT_BREEZE: 'SHAREPOINT_BREEZE',
  SLACK_BREEZE: 'SLACK_BREEZE',
  SMARTSHEET_BREEZE: 'SMARTSHEET_BREEZE',
  STACKOVERFLOW_TEAMS_BREEZE: 'STACKOVERFLOW_TEAMS_BREEZE'
};

// Apps
export const INTEGRATIONS = {
  ADOBE_SIGN: 'ADOBE_SIGN',
  ASANA: 'ASANA',
  BYO_STRIPE: 'BYO_STRIPE',
  DOCUSIGN: 'DOCUSIGN',
  EVENTBRITE: 'EVENTBRITE',
  FACEBOOK_MESSENGER: 'FACEBOOK_MESSENGER',
  GITHUB: 'GITHUB',
  GO_TO_WEBINAR: 'GO_TO_WEBINAR',
  GOOGLE_CALENDAR: 'GOOGLE_CALENDAR',
  GOOGLE_MEET: 'GOOGLE_MEET',
  GOOGLE_SEARCH_CONSOLE: 'GOOGLE_SEARCH_CONSOLE',
  GOOGLE_SHEETS: 'GOOGLE_SHEETS',
  JIRA: 'JIRA',
  LINKEDIN_SALES_NAVIGATOR: 'LINKEDIN_SALES_NAVIGATOR',
  MAILCHIMP: 'MAILCHIMP',
  MS_TEAMS: 'MS_TEAMS',
  OPENAI: 'OPENAI',
  ANTHROPIC: 'ANTHROPIC',
  XAI: 'XAI',
  COHERE: 'COHERE',
  GEMINI: 'GEMINI',
  QUICKBOOKS: 'QUICKBOOKS',
  SALESFORCE: 'SALESFORCE',
  SHOPIFY: 'SHOPIFY',
  SLACK: 'SLACK',
  STRIPE: 'STRIPE',
  SURVEY_MONKEY: 'SURVEY_MONKEY',
  ZOOM: 'ZOOM',
  ACCEL_EVENTS: 'ACCEL_EVENTS',
  AIRMEET: 'AIRMEET',
  AIRTABLE_INTEGRATION: 'AIRTABLE_INTEGRATION',
  BEVY: 'BEVY',
  CED_COMMERCE: 'CED_COMMERCE',
  EVENT_REGIST: 'EVENT_REGIST',
  E_WEBINAR: 'E_WEBINAR',
  // GOOGLE_ASSISTANT: 'GOOGLE_ASSISTANT',
  GOOGLE_CHAT: 'GOOGLE_CHAT',
  GOOGLE_DRIVE: 'GOOGLE_DRIVE',
  HOPIN: 'HOPIN',
  MAKE_WEB_BETTER: 'MAKE_WEB_BETTER',
  OFFICE365: 'OFFICE365',
  ON_24: 'ON_24',
  ONE_SIGNAL: 'ONE_SIGNAL',
  PRESTASHOP: 'PRESTASHOP',
  SIMPLE_EVENTS: 'SIMPLE_EVENTS',
  TRELLO: 'TRELLO',
  UBER_CONFERENCE: 'UBER_CONFERENCE',
  UNIFIC: 'UNIFIC',
  // WORDPRESS: 'WORDPRESS',
  OKTA_SCIM: 'OKTA_SCIM',
  GOOGLE_SCIM: 'GOOGLE_SCIM',
  ACTIVE_DIRECTORY_SCIM: 'ACTIVE_DIRECTORY_SCIM',
  INWINK: 'INWINK',
  GOLDCAST_EVENTS: 'GOLDCAST_EVENTS',
  HUMANITIX: 'HUMANITIX',
  WEBINARGEEK: 'WEBINARGEEK',
  ICAPTURE: 'ICAPTURE',
  TWENTYTHREE: 'TWENTYTHREE',
  CVENT: 'CVENT',
  LIVEWEBINAR: 'LIVEWEBINAR',
  HUBSPOT_APP_FOR_ZOOM_MEETINGS: 'HUBSPOT_APP_FOR_ZOOM_MEETINGS',
  SETTINGS_FRAMEWORK_BLUEPRINT_ATS: 'SETTINGS_FRAMEWORK_BLUEPRINT_ATS',
  ZAPIER: 'ZAPIER',
  ZOOMINFO_PROSPECTING: 'ZOOMINFO_PROSPECTING'
};
export const INTEGRATIONS_ADS_APPS = {
  META_ADS: 'META_ADS',
  GOOGLE_ADS: 'GOOGLE_ADS',
  LINKEDIN_ADS: 'LINKEDIN_ADS'
};
//appIds for ads integrations - https://sourcegraph.hubteam.com/git.hubteam.com/HubSpot/Ads@d7fd7007cd5fe2e84685c55e4770ddaac7a8e569/-/blob/AdsNetworkClients/src/main/config/AdsNetworkClientsConfig.xml

export const INTEGRATIONS_SOCIAL_APPS = {
  FACEBOOK: 'FACEBOOK',
  INSTAGRAM: 'INSTAGRAM',
  TWITTER: 'TWITTER',
  LINKEDIN: 'LINKEDIN',
  YOUTUBE: 'YOUTUBE'
};
//appIds for social integrations - https://git.hubteam.com/HubSpot/Broadcast/blob/master/SocialShared/src/main/config/socialshared.xml#L67

export const INTEGRATIONS_MAIL_APPS = {
  GMAIL: 'GMAIL',
  OUTLOOK: 'OUTLOOK'
};
export const INTEGRATIONS_INBOXES_APPS = {
  FACEBOOK_MESSENGER: 'FACEBOOK_MESSENGER'
};
export const INTEGRATIONS_INTERNAL_NON_HS_BUILT_APPS = Object.assign({}, INTEGRATIONS_ADS_APPS, INTEGRATIONS_SOCIAL_APPS, INTEGRATIONS_MAIL_APPS, INTEGRATIONS_INBOXES_APPS);
export const INTEGRATIONS_APPS = Object.assign({}, INTEGRATIONS, INTEGRATIONS_DATA_SYNC, INTEGRATIONS_AI_CONNECTORS, INTEGRATIONS_DEMO, INTEGRATIONS_DASHWORKS, INTEGRATIONS_INTERNAL_NON_HS_BUILT_APPS);
// TODO: add offering ID to IntegrationsAppsData model
export const INTEGRATIONS_APPS_DATA = {
  [INTEGRATIONS_APPS.META_ADS]: {
    displayName: 'Meta Ads',
    appIds: {
      QA: 1162949,
      PROD: 179777
    }
  },
  [INTEGRATIONS_APPS.GOOGLE_ADS]: {
    displayName: 'Google Ads',
    appIds: {
      QA: 1162973,
      PROD: 180781
    }
  },
  [INTEGRATIONS_APPS.GOOGLE_MEET]: {
    displayName: 'Google Meet',
    appIds: {
      QA: 1203913,
      PROD: 226062
    }
  },
  [INTEGRATIONS_APPS.LINKEDIN_ADS]: {
    displayName: 'LinkedIn Ads',
    appIds: {
      QA: 1162974,
      PROD: 180782
    }
  },
  [INTEGRATIONS_APPS.FACEBOOK]: {
    displayName: 'Facebook',
    appIds: {
      QA: 1162946,
      PROD: 179775
    }
  },
  [INTEGRATIONS_APPS.INSTAGRAM]: {
    displayName: 'Instagram',
    appIds: {
      QA: 1175314,
      PROD: 198219
    }
  },
  [INTEGRATIONS_APPS.LINKEDIN]: {
    displayName: 'LinkedIn',
    appIds: {
      QA: 1162948,
      PROD: 180783
    }
  },
  [INTEGRATIONS_APPS.TWITTER]: {
    displayName: 'X',
    appIds: {
      QA: 1162947,
      PROD: 179776
    }
  },
  [INTEGRATIONS_APPS.YOUTUBE]: {
    displayName: 'YouTube',
    appIds: {
      QA: 1162976,
      PROD: 180785
    }
  },
  [INTEGRATIONS_APPS.GMAIL]: {
    displayName: 'Gmail',
    appIds: {
      QA: 1164181,
      PROD: 184004
    }
  },
  [INTEGRATIONS_APPS.OUTLOOK]: {
    displayName: 'Office365',
    appIds: {
      QA: 1164182,
      PROD: 184007
    }
  },
  [INTEGRATIONS_APPS.MSDYNAMICS]: {
    displayName: 'Microsoft Dynamics',
    appIds: {
      QA: 1208252,
      PROD: 235999
    }
  },
  [INTEGRATIONS_APPS.NETSUITE]: {
    displayName: 'NetSuite',
    appIds: {
      QA: 1204058,
      PROD: 226318
    }
  },
  [INTEGRATIONS_APPS.SALESLOFT]: {
    displayName: 'SalesLoft',
    appIds: {
      QA: 1208255,
      PROD: 236003
    }
  },
  [INTEGRATIONS_APPS.ZOHOCRM]: {
    displayName: 'Zoho CRM',
    appIds: {
      QA: 1208260,
      PROD: 236009
    }
  },
  [INTEGRATIONS_APPS.CHAT_GPT_CONNECTOR]: {
    displayName: 'HubSpot Connector for ChatGPT',
    appIds: {
      QA: 20453644,
      PROD: 12360546
    }
  },
  [INTEGRATIONS_APPS.CLAUDE_CONNECTOR]: {
    displayName: 'HubSpot Connector for Claude',
    appIds: {
      QA: 22418931,
      PROD: 16228553
    }
  },
  [INTEGRATIONS_APPS.SALESFORCE]: {
    displayName: 'Salesforce',
    appIds: {
      QA: 1160722,
      PROD: 38577
    }
  },
  [INTEGRATIONS_APPS.SALESFORCE_DATA_SYNC]: {
    displayName: 'Salesforce',
    appIds: {
      QA: 5840412,
      PROD: 2007421
    }
  },
  [INTEGRATIONS_APPS.SLACK]: {
    displayName: 'Slack',
    appIds: {
      QA: 1162214,
      PROD: 60729
    }
  },
  [INTEGRATIONS_APPS.MS_TEAMS]: {
    displayName: 'Microsoft Teams',
    appIds: {
      QA: 1202021,
      PROD: 221635
    }
  },
  [INTEGRATIONS_APPS.SHOPIFY]: {
    displayName: 'Shopify',
    appIds: {
      QA: 1161155,
      PROD: 51381
    }
  },
  [INTEGRATIONS_APPS.SHOPIFY_DATA_SYNC]: {
    displayName: 'Shopify',
    appIds: {
      QA: 1920453,
      PROD: 542084
    }
  },
  [INTEGRATIONS_APPS.QUICKBOOKS]: {
    displayName: 'QuickBooks Online',
    appIds: {
      QA: 1165378,
      PROD: 188574
    }
  },
  [INTEGRATIONS_APPS.QUICKBOOKS_DATA_SYNC]: {
    displayName: 'QuickBooks Online',
    appIds: {
      QA: 1920452,
      PROD: 542129
    }
  },
  [INTEGRATIONS_APPS.ADOBE_SIGN]: {
    displayName: 'Adobe Sign',
    appIds: {
      QA: 10021866,
      PROD: 3560422
    }
  },
  [INTEGRATIONS_APPS.DOCUSIGN]: {
    displayName: 'DocuSign',
    appIds: {
      QA: 1203058,
      PROD: 224321
    }
  },
  [INTEGRATIONS_APPS.EVENTBRITE]: {
    displayName: 'Eventbrite',
    appIds: {
      QA: 1159843,
      PROD: 28564
    }
  },
  [INTEGRATIONS_APPS.FACEBOOK_MESSENGER]: {
    displayName: 'Facebook Messenger',
    appIds: {
      QA: 1174892,
      PROD: 204269
    }
  },
  // Acceptance Testing Demo NetSute App
  [INTEGRATIONS_APPS.NETSUITE_DEMO]: {
    displayName: 'NetSuite (Demo)',
    appIds: {
      QA: 1205036,
      PROD: 362342
    }
  },
  // integrations from disconnectionConfigs, TODO:need to update displayNames
  [INTEGRATIONS.ASANA]: {
    displayName: '',
    appIds: {
      QA: 1163608,
      PROD: 188672
    }
  },
  [INTEGRATIONS.GOOGLE_SHEETS]: {
    displayName: '',
    appIds: {
      QA: 1265780,
      PROD: 228553
    }
  },
  [INTEGRATIONS.GOOGLE_CALENDAR]: {
    displayName: '',
    appIds: {
      QA: 1160472,
      PROD: 35224
    }
  },
  [INTEGRATIONS.GOOGLE_SEARCH_CONSOLE]: {
    displayName: '',
    appIds: {
      QA: 1206938,
      PROD: 178446
    }
  },
  [INTEGRATIONS.GO_TO_WEBINAR]: {
    displayName: '',
    appIds: {
      QA: 1158066,
      PROD: 35161
    }
  },
  [INTEGRATIONS.JIRA]: {
    displayName: '',
    appIds: {
      QA: 1175189,
      PROD: 205407
    }
  },
  [INTEGRATIONS.OPENAI]: {
    displayName: 'OpenAI',
    appIds: {
      QA: 14310395,
      PROD: 6922949
    }
  },
  [INTEGRATIONS.ANTHROPIC]: {
    displayName: 'Anthropic',
    appIds: {
      QA: 16576286,
      PROD: 9379871
    }
  },
  [INTEGRATIONS.XAI]: {
    displayName: 'xAI',
    appIds: {
      QA: 17550320,
      PROD: 10704890
    }
  },
  [INTEGRATIONS.COHERE]: {
    displayName: 'Cohere',
    appIds: {
      QA: 17729414,
      PROD: 10960790
    }
  },
  [INTEGRATIONS.GEMINI]: {
    displayName: 'Gemini',
    appIds: {
      QA: 18959567,
      PROD: 12747241
    }
  },
  [INTEGRATIONS.BYO_STRIPE]: {
    displayName: '',
    appIds: {
      QA: 4985279,
      PROD: 362340
    }
  },
  [INTEGRATIONS.SURVEY_MONKEY]: {
    displayName: '',
    appIds: {
      QA: 1160471,
      PROD: 35186
    }
  },
  [INTEGRATIONS.STRIPE]: {
    displayName: '',
    appIds: {
      QA: 1162443,
      PROD: 63044
    }
  },
  [INTEGRATIONS.GITHUB]: {
    displayName: '',
    appIds: {
      QA: 3044142,
      PROD: 3044142
    }
  },
  [INTEGRATIONS.LINKEDIN_SALES_NAVIGATOR]: {
    displayName: '',
    appIds: {
      QA: 1161054,
      PROD: 42082
    }
  },
  [INTEGRATIONS.MAILCHIMP]: {
    displayName: '',
    appIds: {
      QA: 1164505,
      PROD: 56440
    }
  },
  [INTEGRATIONS.ZOOM]: {
    displayName: 'Zoom',
    appIds: {
      QA: 1162897,
      PROD: 178192
    }
  },
  [INTEGRATIONS.ZOOMINFO_PROSPECTING]: {
    displayName: 'ZoomInfo',
    appIds: {
      QA: 31562779,
      PROD: 30423594
    }
  },
  // Dashworks/Breeze Apps
  [INTEGRATIONS_DASHWORKS.ASANA_BREEZE]: {
    displayName: 'Asana (for Breeze)',
    appIds: {
      QA: 21361649,
      PROD: 15757528
    }
  },
  [INTEGRATIONS_DASHWORKS.AZURE_DEVOPS_BREEZE]: {
    displayName: 'Azure DevOps (for Breeze)',
    appIds: {
      QA: 20332460,
      PROD: 14658526
    }
  },
  [INTEGRATIONS_DASHWORKS.BOX_BREEZE]: {
    displayName: 'Box (for Breeze)',
    appIds: {
      QA: 21361762,
      PROD: 16147293
    }
  },
  [INTEGRATIONS_DASHWORKS.CONFLUENCE_BREEZE]: {
    displayName: 'Confluence (for Breeze)',
    appIds: {
      QA: 19956024,
      PROD: 14114216
    }
  },
  [INTEGRATIONS_DASHWORKS.DROPBOX_BREEZE]: {
    displayName: 'Dropbox (for Breeze)',
    appIds: {
      QA: 21361684,
      PROD: 16147236
    }
  },
  [INTEGRATIONS_DASHWORKS.GMAIL_BREEZE]: {
    displayName: 'Gmail (for Breeze)',
    appIds: {
      QA: 19767525,
      PROD: 13823852
    }
  },
  [INTEGRATIONS_DASHWORKS.GOOGLE_DRIVE_BREEZE]: {
    displayName: 'Google Drive (for Breeze)',
    appIds: {
      QA: 19768331,
      PROD: 13824211
    }
  },
  [INTEGRATIONS_DASHWORKS.JIRA_BREEZE]: {
    displayName: 'Jira (for Breeze)',
    appIds: {
      QA: 20331833,
      PROD: 14657622
    }
  },
  [INTEGRATIONS_DASHWORKS.LINEAR_BREEZE]: {
    displayName: 'Linear (for Breeze)',
    appIds: {
      QA: 21559382,
      PROD: 16432607
    }
  },
  [INTEGRATIONS_DASHWORKS.MSTEAMS_BREEZE]: {
    displayName: 'Microsoft Teams (for Breeze)',
    appIds: {
      QA: 19768560,
      PROD: 13823956
    }
  },
  [INTEGRATIONS_DASHWORKS.ONEDRIVE_BREEZE]: {
    displayName: 'OneDrive (for Breeze)',
    appIds: {
      QA: 19768777,
      PROD: 13824019
    }
  },
  [INTEGRATIONS_DASHWORKS.OUTLOOK_BREEZE]: {
    displayName: 'Outlook (for Breeze)',
    appIds: {
      QA: 19768635,
      PROD: 13824166
    }
  },
  [INTEGRATIONS_DASHWORKS.PRODUCTBOARD_BREEZE]: {
    displayName: 'Productboard (for Breeze)',
    appIds: {
      QA: 21741290,
      PROD: 16628418
    }
  },
  [INTEGRATIONS_DASHWORKS.SHAREPOINT_BREEZE]: {
    displayName: 'SharePoint (for Breeze)',
    appIds: {
      QA: 19768705,
      PROD: 13824042
    }
  },
  [INTEGRATIONS_DASHWORKS.SLACK_BREEZE]: {
    displayName: 'Slack (for Breeze)',
    appIds: {
      QA: 19764048,
      PROD: 13697285
    }
  },
  [INTEGRATIONS_DASHWORKS.SMARTSHEET_BREEZE]: {
    displayName: 'Smartsheet (for Breeze)',
    appIds: {
      QA: 21559054,
      PROD: 16432527
    }
  },
  [INTEGRATIONS_DASHWORKS.DOCUMENT360_BREEZE]: {
    displayName: 'Document360 (for Breeze)',
    appIds: {
      QA: 22050238,
      PROD: 17045734
    }
  },
  [INTEGRATIONS_DASHWORKS.GITBOOK_BREEZE]: {
    displayName: 'GitBook (for Breeze)',
    appIds: {
      QA: 22050242,
      PROD: 17045735
    }
  },
  [INTEGRATIONS_DASHWORKS.GURU_BREEZE]: {
    displayName: 'Guru (for Breeze)',
    appIds: {
      QA: 21714619,
      PROD: 16617295
    }
  },
  [INTEGRATIONS_DASHWORKS.HELPJUICE_BREEZE]: {
    displayName: 'Helpjuice (for Breeze)',
    appIds: {
      QA: 22050244,
      PROD: 17045736
    }
  },
  [INTEGRATIONS_DASHWORKS.README_BREEZE]: {
    displayName: 'ReadMe (for Breeze)',
    appIds: {
      QA: 22050245,
      PROD: 17045737
    }
  },
  [INTEGRATIONS_DASHWORKS.STACKOVERFLOW_TEAMS_BREEZE]: {
    displayName: 'Stack Overflow for Teams (for Breeze)',
    appIds: {
      QA: 22050247,
      PROD: 17045740
    }
  },
  [INTEGRATIONS.ACCEL_EVENTS]: {
    displayName: 'Accel Events',
    appIds: {
      QA: 1607902,
      PROD: 283817
    }
  },
  [INTEGRATIONS.AIRMEET]: {
    displayName: 'Airmeet',
    appIds: {
      QA: 1757672,
      PROD: 468948
    }
  },
  [INTEGRATIONS.AIRTABLE_INTEGRATION]: {
    displayName: 'Airtable',
    appIds: {
      QA: 1264322,
      PROD: 272852
    }
  },
  [INTEGRATIONS.BEVY]: {
    displayName: 'Bevy',
    appIds: {
      QA: 1506491,
      PROD: 308299
    }
  },
  [INTEGRATIONS.CED_COMMERCE]: {
    displayName: 'CedCommerce',
    appIds: {
      QA: 163225,
      PROD: 163225
    }
  },
  [INTEGRATIONS.EVENT_REGIST]: {
    displayName: 'EventRegist',
    appIds: {
      QA: 1757673,
      PROD: 468398
    }
  },
  [INTEGRATIONS.E_WEBINAR]: {
    displayName: 'eWebinar',
    appIds: {
      QA: 1268979,
      PROD: 237329
    }
  },
  [INTEGRATIONS.GOOGLE_CHAT]: {
    displayName: 'Google Chat',
    appIds: {
      QA: 9108910,
      PROD: 3280929
    }
  },
  [INTEGRATIONS.GOOGLE_DRIVE]: {
    displayName: 'Google Drive',
    appIds: {
      QA: 18569471,
      PROD: 12177578
    }
  },
  [INTEGRATIONS.HOPIN]: {
    displayName: 'Hopin',
    appIds: {
      QA: 1332915,
      PROD: 284333
    }
  },
  [INTEGRATIONS.MAKE_WEB_BETTER]: {
    displayName: 'Make Web Better',
    appIds: {
      QA: 58426,
      PROD: 58426
    }
  },
  [INTEGRATIONS.OFFICE365]: {
    displayName: 'Office 365',
    appIds: {
      QA: 1206939,
      PROD: 184945
    }
  },
  [INTEGRATIONS.ON_24]: {
    displayName: 'ON24',
    appIds: {
      QA: 1757674,
      PROD: 480960
    }
  },
  [INTEGRATIONS.ONE_SIGNAL]: {
    displayName: 'OneSignal',
    appIds: {
      QA: 1201692,
      PROD: 238763
    }
  },
  [INTEGRATIONS.PRESTASHOP]: {
    displayName: 'PrestaShop',
    appIds: {
      QA: 1380165,
      PROD: 275636
    }
  },
  [INTEGRATIONS.SIMPLE_EVENTS]: {
    displayName: 'Simple Events',
    appIds: {
      QA: 5765009,
      PROD: 1208571
    }
  },
  [INTEGRATIONS.TRELLO]: {
    displayName: 'Trello',
    appIds: {
      QA: 1205037,
      PROD: 230691
    }
  },
  [INTEGRATIONS.UBER_CONFERENCE]: {
    displayName: 'UberConference',
    appIds: {
      QA: 1160103,
      PROD: 28662
    }
  },
  [INTEGRATIONS.UNIFIC]: {
    displayName: 'Unific',
    appIds: {
      QA: 28754,
      PROD: 28754
    }
  },
  [INTEGRATIONS.OKTA_SCIM]: {
    displayName: 'Okta SCIM',
    appIds: {
      QA: 1204574,
      PROD: 233741
    }
  },
  [INTEGRATIONS.GOOGLE_SCIM]: {
    displayName: 'Google SCIM',
    appIds: {
      QA: 6958331,
      PROD: 2225632
    }
  },
  [INTEGRATIONS.ACTIVE_DIRECTORY_SCIM]: {
    displayName: 'Active Directory SCIM',
    appIds: {
      QA: 6958526,
      PROD: 233742
    }
  },
  [INTEGRATIONS.INWINK]: {
    displayName: 'InWink',
    appIds: {
      QA: 4265046,
      PROD: 1201645
    }
  },
  [INTEGRATIONS.GOLDCAST_EVENTS]: {
    displayName: 'Goldcast Events',
    appIds: {
      QA: 2526946,
      PROD: 480915
    }
  },
  [INTEGRATIONS.HUMANITIX]: {
    displayName: 'Humanitix',
    appIds: {
      QA: 2670458,
      PROD: 644413
    }
  },
  [INTEGRATIONS.WEBINARGEEK]: {
    displayName: 'WebinarGeek',
    appIds: {
      QA: 1268660,
      PROD: 40724
    }
  },
  [INTEGRATIONS.ICAPTURE]: {
    displayName: 'iCapture',
    appIds: {
      QA: 1269027,
      PROD: 40901
    }
  },
  [INTEGRATIONS.TWENTYTHREE]: {
    displayName: 'TwentyThree',
    appIds: {
      QA: 1269240,
      PROD: 36304
    }
  },
  [INTEGRATIONS.CVENT]: {
    displayName: 'Cvent',
    appIds: {
      QA: 4307267,
      PROD: 1018074
    }
  },
  [INTEGRATIONS.LIVEWEBINAR]: {
    displayName: 'LiveWebinar',
    appIds: {
      QA: 1936263,
      PROD: 212670
    }
  },
  // This is the app used within Zoom browser for Zoom meetings (built by HubSpot)
  [INTEGRATIONS.HUBSPOT_APP_FOR_ZOOM_MEETINGS]: {
    displayName: 'HubSpot App for Zoom Meetings',
    appIds: {
      QA: 2486568,
      PROD: 510050
    }
  },
  [INTEGRATIONS_DEMO.DEMO_APP]: {
    displayName: 'Demo App',
    appIds: {
      QA: 'DEMO_APP',
      PROD: 'DEMO_APP'
    }
  },
  [INTEGRATIONS_DEMO.DEVHUBTESTAPP]: {
    displayName: 'DevHub Test App',
    appIds: {
      QA: 1269370,
      PROD: 275736
    }
  },
  // Only used for acceptance tests - can be updated here: https://app.hubspotqa.com/developer/883585569
  [INTEGRATIONS.SETTINGS_FRAMEWORK_BLUEPRINT_ATS]: {
    displayName: 'Settings Framework Blueprint ATS',
    appIds: {
      QA: 3186275,
      PROD: 3186275
    }
  },
  [INTEGRATIONS.ZAPIER]: {
    displayName: 'Zapier',
    appIds: {
      QA: 1164184,
      PROD: 25200
    }
  }
};
const appNameByAppIdMap = Object.keys(INTEGRATIONS_APPS_DATA).reduce((result, name) => Object.assign({}, result, {
  [INTEGRATIONS_APPS_DATA[name].appIds[CURRENT_ENV]]: name
}), {});
export const getAppIdByAppName = appName => INTEGRATIONS_APPS_DATA[appName].appIds[CURRENT_ENV];
export const getAppDataByAppName = appName => INTEGRATIONS_APPS_DATA[appName];
export const getAppDataByAppId = appId => INTEGRATIONS_APPS_DATA[appNameByAppIdMap[appId]];
export const getAppNameByAppId = appId => appNameByAppIdMap[appId];
export const getProdAppIdByQaAppId = qaAppId => {
  const app = Object.keys(INTEGRATIONS_APPS_DATA).find(appName => INTEGRATIONS_APPS_DATA[appName].appIds.QA === qaAppId);
  if (!app) {
    return undefined;
  }
  return INTEGRATIONS_APPS_DATA[app].appIds.PROD;
};
export let InternalAppType;
(function (InternalAppType) {
  InternalAppType["SOCIAL"] = "SOCIAL";
  InternalAppType["ADS"] = "ADS";
  InternalAppType["EMAIL"] = "EMAIL";
  InternalAppType["INBOXES"] = "INBOXES";
})(InternalAppType || (InternalAppType = {}));
export const getInternalAppType = appId => {
  const app = getAppNameByAppId(appId);
  if (!app) {
    return undefined;
  }
  if (INTEGRATIONS_SOCIAL_APPS[app]) {
    return InternalAppType.SOCIAL;
  }
  if (INTEGRATIONS_ADS_APPS[app]) {
    return InternalAppType.ADS;
  }
  if (INTEGRATIONS_MAIL_APPS[app]) {
    return InternalAppType.EMAIL;
  }
  if (INTEGRATIONS_INBOXES_APPS[app]) {
    return InternalAppType.INBOXES;
  }
  return undefined;
};
export const isAIConnectorApp = appId => {
  const appName = getAppNameByAppId(appId);
  if (!appName) return false;
  return Object.values(INTEGRATIONS_AI_CONNECTORS).includes(appName);
};
export const APP_KEY_BY_APP_ID = Object.entries(INTEGRATIONS_APPS_DATA).reduce((acc, curr) => {
  const [appKey, data] = curr;
  const appId = data.appIds[CURRENT_ENV];
  acc[appId] = appKey;
  return acc;
}, {});
export const getAppKeyByAppId = (appId, defaults) => APP_KEY_BY_APP_ID[appId] || defaults;